import { InputField as UnstyledInputField, withClassName } from '@epages/react-components'

export default withClassName('ep-form-text-field', ['focus'])(UnstyledInputField)
